import { render, staticRenderFns } from "./UserTaskReactionConfig.vue?vue&type=template&id=38ebb184&scoped=true"
import script from "./UserTaskReactionConfig.vue?vue&type=script&lang=js"
export * from "./UserTaskReactionConfig.vue?vue&type=script&lang=js"
import style0 from "./UserTaskReactionConfig.vue?vue&type=style&index=0&id=38ebb184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ebb184",
  null
  
)

export default component.exports